import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { PageComponent } from '../../components/page/page.component';
import { PointOfServiceComponent } from '../../components/point-of-service/point-of-service.component';

@Component({
  selector: 'app-point-of-service-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    PointOfServiceComponent
  ],
  templateUrl: './point-of-service-page.component.html',
  styleUrls: ['./point-of-service-page.component.css']
})
export class PointOfServicePageComponent {
  pointOfServiceId: string;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute) {
    this.pointOfServiceId = '';
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.pointOfServiceId = Util.safeString(pathParams.get('pointOfServiceId'));
  }
}
